import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./WorldwideReac.css";

const WorldwideReac = () => {
  return (
    <>
      <div className="WorldwideReac">
        <div className="container">
          <div className="row p-lg-4">
            <div className="col-md-6">
              <h1 className="headings">
                <span>Your Global</span> Journey, Powered by Local Expertise
              </h1>
              <p className="mt-2 mb-md-2 mb-lg-3 mb-xxl-4  grotesk-headings">
                At Blueberry Travel, we’re not just responsible for taking you
                to places—we bring your travel dream to life. With a global
                network that stretches across continents, we ensure a smooth and
                stress-free experience in every destination, from bustling
                business hubs to emerging markets.
              </p>
              <p className="mt-lg-3 mt-md-2  grotesk-headings">
                With an in-depth understanding of local customs, regulations,
                and industry demands, our team ensures a smooth experience for
                corporate travelers. Whether it’s about booking flights, ground
                transportation, or accommodation. Experience the difference with
                Blueberry Travel—where every journey is an opportunity for
                success.
              </p>

              <div className="carouselCaption text-black mt-xxl-4">
                <a href="/corporate-travel">
                  <button className="btn text-dark mt-md-0  worldwideBtn text text-uppercase explore">
                    Explore Blueberry Travel’s Global Travel Programs
                  </button>
                </a>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Worlwide-img.png"
                  alt=""
                  className="img-fluid worlwide-img"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorldwideReac;
